import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../contexts/IframeAuthProvider'
import { Button } from '../components/ui/Button'
import { LoadingSpinner } from '../components/ui/LoadingSpinner'
import { ExternalLink } from 'lucide-react'

export const LoginPage: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth()
  const [isRedirecting, setIsRedirecting] = useState(false)
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  const darwinLoginUrl = import.meta.env.VITE_DARWIN_LOGIN_URL || 'https://govern.staging.darwingov.com/login'

  // If already authenticated, redirect to intended page or dashboard
  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      const redirectTo = searchParams.get('return_to') || '/dashboard'
      console.log('LoginPage: User is authenticated, redirecting to:', redirectTo)
      navigate(redirectTo, { replace: true })
    }
  }, [isAuthenticated, isLoading, navigate, searchParams])

  const handleLogin = () => {
    setIsRedirecting(true)
    const returnTo = searchParams.get('return_to') || '/dashboard'
    const fullReturnUrl = `${window.location.origin}${returnTo}`
    window.location.href = `${darwinLoginUrl}?return_to=${encodeURIComponent(fullReturnUrl)}`
  }

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner size="lg" />
          <p className="mt-4 text-gray-600">Checking authentication...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          {/* Darwin.bidchecker Logo - using proper Darwin logo from Figma */}
          <div className="flex justify-center items-baseline mb-8">
            <img
              src="/propalyst-logo.svg"
              alt="Darwin logo"
              className="h-6 w-auto"
            />
            <span className="text-lg font-medium text-gray-500" style={{ marginLeft: '1px', marginBottom: '1px' }}>
              .bidchecker
            </span>
          </div>

          <p className="mt-2 text-center text-sm text-gray-600">
            Automated RFP evaluation and vendor proposal analysis
          </p>
        </div>

        <div className="mt-8 space-y-6">
          <div className="text-center">
            <p className="text-sm text-gray-600 mb-6">
              Sign in with your Darwin AI credentials
            </p>

            <Button
              onClick={handleLogin}
              className="w-full mb-4"
              loading={isRedirecting}
              disabled={isRedirecting}
            >
              {isRedirecting ? (
                'Redirecting...'
              ) : (
                <>
                  <ExternalLink className="w-5 h-5 mr-2" />
                  Sign in with Govern
                </>
              )}
            </Button>

          </div>
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            Powered by Darwin AI
          </p>
        </div>
      </div>
    </div>
  )
}

export default LoginPage